module.exports = __webpack_public_path__ + "static/media/logo.1e1a4c66.png";